var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "relative min-h-hero lg:flex lg:flex-col pb-8 lg:pb-7 bg-paint",
    },
    [
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [
          _vm.showSelector
            ? _c("CoatingColourSelector", {
                attrs: {
                  palettes: _vm.palettes,
                  product: _vm.product,
                  "selected-colour": _vm.selectedColour,
                },
                on: { "select-colour": _vm.handleSelectColour },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "relative flex-1 lg:flex lg:items-center lg:justify-start",
        },
        [
          _c(
            "div",
            {
              staticClass:
                "lg:absolute lg:inset-0 flex items-center justify-center lg:pt-smh z-10",
            },
            [
              _c(
                "div",
                { staticClass: "w-4/5 sm:w-1/2 lg:w-1/3 pt-8 lg:pt-shh" },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "relative h-0 pt-full rounded-full bg-grey overflow-hidden",
                    },
                    [
                      _vm._l(_vm.palettes, function (palette, index) {
                        return [
                          _vm._l(palette.colours, function (item, index) {
                            return [
                              _c("img", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: item.id === _vm.selectedColour.id,
                                    expression: "item.id === selectedColour.id",
                                  },
                                ],
                                staticClass:
                                  "absolute inset-0 w-full object-cover",
                                attrs: { src: item.image[0].url },
                              }),
                            ]
                          }),
                        ]
                      }),
                    ],
                    2
                  ),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "relative px-ogs-large z-20" }, [
            _c(
              "div",
              {
                staticClass:
                  "flex flex-col items-center lg:items-start pt-8 py-28 lg:pt-10 lg:pb-10",
              },
              [
                _c(
                  "label",
                  {
                    staticClass:
                      "text-xxs text-theme font-semibold uppercase mb-1",
                  },
                  [_vm._v("Selected Stain")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "relative mb-5" },
                  [
                    _c("transition", { attrs: { name: "fade" } }, [
                      _vm.isLoading
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "absolute inset-0 flex items-center justify-center z-20",
                              attrs: {
                                role: "alert",
                                "data-testid": "loading-message",
                              },
                            },
                            [
                              _c("LoaderSpinner", {
                                staticClass: "w-10 h-10 text-theme",
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _vm.coloursCount > 1
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "relative transition-opacity duration-300 z-10",
                            class: {
                              "opacity-25": _vm.isLoading,
                              "opacity-100": !_vm.isLoading,
                            },
                          },
                          [
                            _c(
                              "button",
                              {
                                staticClass:
                                  "link flex items-center border-b border-theme py-2 space-x-2",
                                on: {
                                  click: function ($event) {
                                    _vm.showSelector = true
                                  },
                                },
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "text-xl text-theme" },
                                  [_vm._v(_vm._s(_vm.selectedColour.title))]
                                ),
                                _vm._v(" "),
                                _c("div", {
                                  staticClass: "caret bg-theme",
                                  attrs: { "aria-hidden": "true" },
                                }),
                              ]
                            ),
                          ]
                        )
                      : _c(
                          "div",
                          {
                            staticClass: "text-xl text-theme py-2",
                            class: {
                              "opacity-25": _vm.isLoading,
                              "opacity-100": !_vm.isLoading,
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.selectedColour.title) +
                                "\n          "
                            ),
                          ]
                        ),
                  ],
                  1
                ),
              ]
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "relative grid grid-cols-12 gap-x-gs gap-y-8 px-ogs-large lg:py-7 z-20",
        },
        [
          _c(
            "div",
            {
              staticClass:
                "col-span-12 lg:col-span-4 space-y-2 text-center lg:text-left",
            },
            [
              _c("div", { staticClass: "max-w-sm lg:max-w-full mx-auto" }, [
                _c("h1", { staticClass: "text-xl text-theme leading-snug" }, [
                  _vm._v(
                    "\n          " + _vm._s(_vm.product.title) + "\n        "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "p",
                  { staticClass: "text-theme text-theme text-sm md:text-base" },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.product.description) +
                        "\n        "
                    ),
                  ]
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "form",
            {
              staticClass:
                "col-span-12 lg:col-span-8 lg:flex lg:items-end lg:justify-end",
              attrs: { id: "variantForm", name: "variantForm" },
              on: { submit: _vm.handleSubmit },
            },
            [
              _c("ProductVariantSelector", {
                staticClass:
                  "col-span-12 lg:col-span-8 lg:flex lg:items-end lg:justify-end lg:space-x-10",
                attrs: {
                  sheens: _vm.variantSheens,
                  sizes: _vm.variantSizes,
                  "selected-sheen": _vm.selectedSheen,
                  "selected-size": _vm.selectedSize,
                  "open-above": true,
                },
                on: {
                  "change-sheen": function ($event) {
                    _vm.selectedSheen = $event
                  },
                  "change-size": function ($event) {
                    _vm.selectedSize = $event
                  },
                },
              }),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "relative grid grid-cols-12 gap-x-gs gap-y-4 px-ogs-large pt-8 lg:pt-7 lg:border-t lg:border-theme z-20",
        },
        [
          _c(
            "div",
            {
              staticClass:
                "col-span-12 lg:col-span-6 xl:col-span-4 flex items-center",
            },
            [
              _c(
                "button",
                {
                  staticClass: "w-full lg:w-auto btn-soft",
                  on: {
                    click: function ($event) {
                      return _vm.$store.commit("openCoatingCalculator")
                    },
                  },
                },
                [_vm._v("\n        Oil Calculator\n      ")]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "col-span-4 hidden xl:flex items-center justify-center",
            },
            [
              _c(
                "h4",
                {
                  staticClass:
                    "text-theme opacity-70 leading-tight text-center",
                },
                [
                  _vm._v(
                    "\n        Stain: " +
                      _vm._s(_vm.selectedColour.title) +
                      "\n        " +
                      _vm._s(
                        _vm.selectedSheen && ` / ${_vm.selectedSheen.title}`
                      ) +
                      "\n        " +
                      _vm._s(
                        _vm.selectedSize && ` / ${_vm.selectedSize.title}`
                      ) +
                      "\n      "
                  ),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _vm.testPotProductId
            ? _c(
                "div",
                { staticClass: "col-span-12 lg:hidden" },
                [
                  _c(
                    "ProductCoatingTestPot",
                    {
                      staticClass: "w-full btn-soft",
                      attrs: {
                        loading: _vm.isLoading,
                        "colour-title": _vm.selectedColour.title,
                        "test-pot": _vm.testPotSelected,
                        sku: _vm.variantSelected ? _vm.variantSelected.sku : "",
                        "product-title": _vm.product.title,
                        sheen: _vm.selectedSheen.title,
                        "coating-colour": _vm.selectedColour.thumbnail.url,
                        source: "coating_product_page",
                      },
                    },
                    [
                      _vm._v(
                        "Test Pot - $" +
                          _vm._s(
                            _vm.testPotSelected
                              ? _vm.testPotSelected.salePrice
                              : 6
                          )
                      ),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "col-span-12 lg:col-span-6 xl:col-span-4 lg:flex lg:items-center lg:justify-end lg:space-x-3",
            },
            [
              _vm.testPotProductId
                ? _c(
                    "div",
                    { staticClass: "hidden lg:block" },
                    [
                      _c(
                        "ProductCoatingTestPot",
                        {
                          staticClass: "btn-soft",
                          attrs: {
                            loading: _vm.isLoading,
                            "colour-title": _vm.selectedColour.title,
                            "test-pot": _vm.testPotSelected,
                            sku: _vm.variantSelected
                              ? _vm.variantSelected.sku
                              : "",
                            "product-title": _vm.product.title,
                            sheen: _vm.selectedSheen.title,
                            "coating-colour": _vm.selectedColour.thumbnail.url,
                            source: "coating_product_page",
                          },
                        },
                        [
                          _vm._v(
                            "Test Pot - $" +
                              _vm._s(
                                _vm.testPotSelected
                                  ? _vm.testPotSelected.salePrice
                                  : 6
                              )
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("ProductAddToCartForm", {
                attrs: {
                  form: "variantForm",
                  variant: _vm.variantSelected,
                  loading: _vm.isLoading,
                },
              }),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "Portal",
        { attrs: { selector: "#portal-target" } },
        [
          _c("CoatingCalculator", {
            attrs: {
              coating: _vm.product,
              "is-visible": _vm.$store.state.ui.coatingCalculatorIsOpen,
            },
            on: {
              closed: function ($event) {
                return _vm.$store.commit("closeCoatingCalculator")
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }